export default {
  registration: {
    header: {
      title: 'Supplier Registration Page',
      title_esg_data_share: 'ESG Data Share registration page',
    },
    passcode: {
      section_one: 'This is a user registration page for companies that have been requested to use this service.',
      section_two: 'Please enter a passcode to proceed to the registration page.',
      section_three: 'If you do not receive a passcode, please contact the company that requested this service for your company.',
      passcode: 'Passcode',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: 'Incorrect Input.',
      unexpected_error: 'An unexpected error happened',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Please enter your email address to register.',
      email: 'Email address',
      email_placeholder: 'Fill in email address',
    },
    sent: {
      section_one: 'An e-mail has been sent to the e-mail address you entered.',
      section_two: 'Please check the URL in the email and proceed to the account registration.',
      section_three: 'If you do not receive an e-mail within 30 minutes, please contact ',
      section_four: '.',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれは仮反映状態
      section_one: 'The email address you entered has already been registered for your some ASUENE products\' account.',
      section_two: 'Please enter your registered password.',
      password: 'Password',
      password_placeholder: 'Fill in password',
      error_auth: 'Verification failed. Please try again.',
      error_linking: 'Verification failed. Please enter the password again.',
      same_domain_modal: {
        title: '@:registration.form.same_domain_modal.title',
        section: 'The corresponding questionnaire/survey has already been registered to an Asuene ESG account with an email address in the same domain as the email address you entered.\nWould you like to register anyway?',
      },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Please enter your company information and the name of the person in charge.',
      section_three: 'Please log in with your registered account after application and you will be able to respond to the requested survey.',
      buyer_name: 'Buyer',
      expires_date: 'Expiration Date',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: 'Company name',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: '※The email address you entered is displayed',
      phone: 'Phone number',
      phone_placeholder: '0000000000',
      locale: 'Language',
      section_one: 'Please agree to the',
      rule: 'Terms and Conditions',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' and ',
      policy: 'Privacy Policy ',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: 'before proceeding.',
      same_domain_modal: {
        title: 'Confirm your registered account',
        section: 'An Asuene ESG account has already been registered with an email address with the same domain as the email address you entered.\nDo you want to create an account anyway?',
      },
    },
    thanks: {
      section_one: 'Thank you for your application',
      section_two: 'We have sent your login ID and password to the e-mail address you entered.',
      section_three: 'check your email and follow the instructions in the email to login.',
      section_four: 'If you have not received it after 30 minutes,  please notify us at ',
      section_five: '',
      section_six: 'The person in charge will contact you again.',
    },
    expired: {
      section_one: 'The URL provided has already expired.',
      section_two: 'If you wish to use this service, please contact ',
      section_three: 'The person in charge will contact you.',
    },
    error: {
      section_one: 'The URL provided could not be found.',
      section_two: 'We apologize for the inconvenience, but please check the URL again.',
    },
    btn: {
      submit: 'Submit',
      service_top: 'Top',
      login: 'Login',
      register: 'Register',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      sharing_company: 'Sharing Company',
      explain_message: 'After registration, you will be able to view the shared ESG data by logging in with your registered account.',
    },
    share_answer: {
      verify_title: 'Answer access verification',
      description_1: 'The survey answer from {company} are protected by a password.',
      description_2: 'Please enter the password to view the answer.',
    },
  },
}
